"use strict";var t=require("../Guard/isFunction.cjs");exports.isWasmSupported=function(){return"object"==typeof WebAssembly&&(t.isFunction(WebAssembly.instantiateStreaming)||t.isFunction(WebAssembly.instantiate))};
//# sourceMappingURL=isWasmSupported.cjs.map
